/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiWorkflowDefinition, ApiWorkflowRun, ApiWorkflowStory, LockElement, LockedContextDto } from '@Model';
import type { HttpActions, ListInfo, ListRequest, ListRequestWithIds, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of WorkflowDefinitionsController.
 */
export class WorkflowDefinitionsRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls GET /workflow_definitions/{primaryId}
     */
    public get(primaryId: string, include: string | undefined): Promise<Result<ApiWorkflowDefinition>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ApiWorkflowDefinition>>(`/workflow_definitions/${primaryId}`, query);
    }

    /**
     * Calls GET /workflow_definitions:query
     */
    public getListGet(pageNo: number, pageSize: number, include: string | undefined): Promise<Result<ListInfo<ApiWorkflowDefinition>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ListInfo<ApiWorkflowDefinition>>>('/workflow_definitions:query', query);
    }

    /**
     * Calls POST /workflow_definitions:query
     */
    public getListPost(listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiWorkflowDefinition>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiWorkflowDefinition>>, ListRequest>('/workflow_definitions:query', listRequest, query);
    }

    /**
     * Calls POST /workflow_definitions:batch
     */
    public getBatch(listRequest: ListRequestWithIds, include: string | undefined): Promise<Result<ListInfo<ApiWorkflowDefinition>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiWorkflowDefinition>>, ListRequestWithIds>('/workflow_definitions:batch', listRequest, query);
    }

    /**
     * Calls POST /workflow_definitions:prefill
     */
    public createPrefilled(): Promise<Result<ApiWorkflowDefinition>> {
        return this.http.post<Result<ApiWorkflowDefinition>, undefined>('/workflow_definitions:prefill', undefined);
    }

    /**
     * Calls GET /workflow_definitions/{workflowDefinitionId}/story
     */
    public getStory(workflowDefinitionId: string): Promise<Result<ApiWorkflowStory>> {
        return this.http.get<Result<ApiWorkflowStory>>(`/workflow_definitions/${workflowDefinitionId}/story`);
    }

    /**
     * Calls POST /workflow_definitions/{workflowDefinitionId}/workflow_runs:query
     */
    public getRuns(workflowDefinitionId: string, listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiWorkflowRun>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiWorkflowRun>>, ListRequest>(`/workflow_definitions/${workflowDefinitionId}/workflow_runs:query`, listRequest, query);
    }

    /**
     * Calls POST /workflow_definitions/{primaryId}/start_edit_mode
     */
    public startEditMode(primaryId: string): Promise<Result<LockedContextDto<ApiWorkflowDefinition>>> {
        return this.http.post<Result<LockedContextDto<ApiWorkflowDefinition>>, undefined>(`/workflow_definitions/${primaryId}/start_edit_mode`, undefined);
    }

    /**
     * Calls POST /workflow_definitions/{draftId}/commit
     */
    public commitDraft(draftId: string): Promise<Result<ApiWorkflowDefinition>> {
        return this.http.post<Result<ApiWorkflowDefinition>, undefined>(`/workflow_definitions/${draftId}/commit`, undefined);
    }

    /**
     * Calls POST /workflow_definitions/locks
     */
    public lockAll(ids: string[]): Promise<Result<ApiWorkflowDefinition[]>> {
        return this.http.post<Result<ApiWorkflowDefinition[]>, string[]>('/workflow_definitions/locks', ids);
    }

    /**
     * Calls POST /workflow_definitions/{primaryId}/locks
     */
    public lock(primaryId: string): Promise<Result<LockElement>> {
        return this.http.post<Result<LockElement>, undefined>(`/workflow_definitions/${primaryId}/locks`, undefined);
    }

    /**
     * Calls DELETE /workflow_definitions/{primaryId}/locks
     */
    public unlock(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/workflow_definitions/${primaryId}/locks`);
    }

    /**
     * Calls POST /workflow_definitions
     */
    public add(dto: ApiWorkflowDefinition): Promise<Result<ApiWorkflowDefinition>> {
        return this.http.post<Result<ApiWorkflowDefinition>, ApiWorkflowDefinition>('/workflow_definitions', dto);
    }

    /**
     * Calls PUT /workflow_definitions/{primaryId}
     */
    public update(dto: ApiWorkflowDefinition, primaryId: string): Promise<Result<ApiWorkflowDefinition>> {
        return this.http.put<Result<ApiWorkflowDefinition>, ApiWorkflowDefinition>(`/workflow_definitions/${primaryId}`, dto);
    }

    /**
     * Calls PATCH /workflow_definitions
     */
    public putRange(dtos: ApiWorkflowDefinition[]): Promise<Result<ApiWorkflowDefinition[]>> {
        return this.http.patch<Result<ApiWorkflowDefinition[]>, ApiWorkflowDefinition[]>('/workflow_definitions', dtos);
    }

    /**
     * Calls DELETE /workflow_definitions/{primaryId}
     */
    public delete(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/workflow_definitions/${primaryId}`);
    }
}
